import { filter, fromEvent, map } from 'rxjs';
import Carousel from '@components/carousel/dynamicCarousel';

const settings = {
    itemListQuerySelector: '[data-section-name="popularPills"] [data-popular-pills-list]',
    previousQuerySelector: '[data-section-name="popularPills"] [data-left-arrow]',
    nextQuerySelector: '[data-section-name="popularPills"] [data-right-arrow]',
};

// listen for the DOMContentLoaded event to ensure the DOM is fully loaded before updating the popular pills.
const onDomContentLoaded$ = fromEvent(document, 'DOMContentLoaded').pipe(
    map(() => document.querySelector('[data-section-name="popularPills"]')),
    filter(Boolean)
);

onDomContentLoaded$.subscribe(() => {
    const carousel = new Carousel();
    carousel.setSettings(settings);
    carousel.create();
});
